import {Action, handleActions} from "redux-actions";
import {AdminActionTypes} from "./editPortfolioActions";

export interface IPortfolioAdminState {
    editingPlanPortfolio: boolean;
}

export const initialState: IPortfolioAdminState = {
    editingPlanPortfolio: false,
};

const beginEditPlanPortfolio = (state: IPortfolioAdminState, {}: Action<{}>): IPortfolioAdminState => {
    return {...state, editingPlanPortfolio: true};
};

const endEditPlanPortfolio = (state: IPortfolioAdminState, {}: Action<{}>): IPortfolioAdminState => {
    return {...state, editingPlanPortfolio: false};
};

const reducerMap = {
    [AdminActionTypes.BEGIN_EDIT_PORTFOLIO]: beginEditPlanPortfolio,
    [AdminActionTypes.END_EDIT_PORTFOLIO]: endEditPlanPortfolio,
};

export default handleActions<IPortfolioAdminState, { location: { pathname: string } }>(reducerMap, initialState);

export function isEditingPlanPortfolioInner(state: IPortfolioAdminState | undefined): boolean {

    return state !== undefined && state.editingPlanPortfolio;
}
